import React, { useEffect, useState, useRef, VFC, ChangeEvent, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import './funnelList.scss';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import moment from 'moment';
import { useAuth } from '@/lib/auth';
import Utils from '@/utils/util';
import { User } from '@/types';
import 'react-phone-input-2/lib/style.css'; // You may need to import the stylesheet as well
import PhoneInput from 'react-phone-input-2';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { PageHeader } from '@/components/PageHeaders/PageHeader';
import { ReactComponent as BookFunnelIcon } from '@/assets/steam/book-funnel.svg';
import { ReactComponent as ProductFunnelicon } from '@/assets/steam/product-funnel.svg';
import { ReactComponent as Calendericon } from '@/assets/steam/calender-frame.svg';
import { ReactComponent as CalenderRed } from '@/assets/steam/calender-red.svg';
import { ReactComponent as CalenderGreen } from '@/assets/steam/calender-green.svg';
import { ReactComponent as Statusicon } from '@/assets/steam/status-funnel.svg';
import InitialsAvatar from 'react-initials-avatar';

import { Funnel } from '../types/indes';
const FunnelList: VFC<{
    funnelData?: Funnel;
    selectedFunnel?: Funnel;
    onSelectingFunnel(data:any) : void;
    isArchivedFunnel: boolean
    addToArchive(data:any):void; 
    archivedFunnels?: any;
}> = ({ funnelData, selectedFunnel,onSelectingFunnel, isArchivedFunnel, archivedFunnels, addToArchive }) => {
    const { user } = useAuth();

    const FUNNEL_TYPES = {
        BOOK_FUNNEL: '2',
        PRODUCT_FUNNEL: '1',
    };

    return (
        <>
            <div className={`funnel-details-container ${selectedFunnel?.id === funnelData?.id ? 'is-selected' : ''}`} onClick={()=>onSelectingFunnel(funnelData?.id)}>
                <div className='left-panel'>
                    <InitialsAvatar name={funnelData?.institute?.name ? funnelData?.institute?.name.charAt(0).toUpperCase()  : 'S'} className="avatar padding-funnel-list" />
                    {FUNNEL_TYPES.BOOK_FUNNEL !== funnelData?.type ? <BookFunnelIcon className='book-funnel-icon' /> : <ProductFunnelicon className='book-funnel-icon' />}

                </div>
                <div className='right-panel'>
                    <div className='contact-details'>
                        <div className='name-institute'>
                            <div className='name'>
                            {funnelData?.institute?.name}
                            </div>
                            <div className='institute remove-wrap'>
                            
                                {funnelData?.assignedUser?.name} | {Utils.formatDate(funnelData?.coverageDate)}
                            </div>

                        </div>

                        <div className={`deal-size ${isArchivedFunnel ? 'archived-funnel' : ''}`}>
                        {isArchivedFunnel ? <label  key={funnelData?.id}
          htmlFor={`option-check-${funnelData?.id}`} className="check-container is-archived">
                                        <input
                                           checked={archivedFunnels.includes(funnelData?.id)}
                                            id={`option-check-${funnelData?.id}`}
                                            type="checkbox"
                                            onChange={() => addToArchive(funnelData?.id)}
                                        />
                                        <span className="checkmark"></span>
                                    </label> : <>
                            {Utils.convertDealSize(Number(funnelData?.dealSize))}</>}
                        </div>

                    </div>

                    <div className='contact-details mt-3'>
                        <div className='name-institute'>
                            <div className={`date ${Utils.getDateConfig(funnelData?.followUpDate) === 'today'  ? 'is-today' : '' } ${Utils.getDateConfig(funnelData?.followUpDate) === 'expired'  ? 'is-expired' : '' }`}>
                                {Utils.getDateConfig(funnelData?.followUpDate) === 'today' ? <CalenderGreen /> : Utils.getDateConfig(funnelData?.followUpDate) === 'expired'? <CalenderRed/> : <Calendericon/>}
                                {funnelData?.followUpDate ? Utils.formatDate(funnelData?.followUpDate) : ''}
                            </div>

                        </div>

                        <div className='funnel-status'>
                            <Statusicon /> {funnelData?.stage?.name}
                        </div>

                    </div>

                </div>


            </div>


        </>
    );
};




export default FunnelList;
